import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const generationPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Generation },
    { actions: [Actions.read], subject: Models.Generations },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Generation },
    { actions: [Actions.read], subject: Models.Generations },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Generation },
    { actions: [Actions.read], subject: Models.Generations },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.Generation },
    { actions: [Actions.read], subject: Models.Generations },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
